const contentDisposition = require('content-disposition');
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { config } from '../config';
import { acceptImageFormats } from '../config/index';

// const acceptImageFormats = '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.webp,.WEBP,.awebp,.AWEBP,.heic,.HEIC,.pic_hd'
const imgUrlReg = new RegExp(`(.+\\/)+.+(\\.(${acceptImageFormats.replace(/\./g, '').replace(/,/g, '|')}))$`);

function isValidImgUrl(url = '') {
  return imgUrlReg.test(url);
}

function getType(contentType) {
  if (/application\/json/.test(contentType)) {
    return 'json';
  }
  if (/application\/octet-stream/.test(contentType)) {
    return 'stream';
  }
  return '';
}

export function showErrorMessage(message) {
  message &&
    ElMessage({
      type: 'error',
      offset: 90,
      message,
    });
}

/* 单图片下载 */
export function downloadSingle(file) {
  axios({
    method: 'post',
    url: config.baseUrl + 'dcwytimgapi/download/single',
    // url: 'http://47.113.200.218:3030/' + 'dcwytimgapi/download/single',
    data: {
      name: file.name,
      src: file.src,
    },
    responseType: 'blob',
  })
    .then(async (res) => {
      // console.log('download single 1: ', res);
      const type = getType(res.headers['content-type']);
      const contentDispositionData = contentDisposition.parse(res.headers['content-disposition']);
      // console.warn(contentDispositionData);
      const filename = decodeURIComponent(contentDispositionData.parameters.filename);
      console.log(filename)

      let message = '';
      if (type === 'json') {
        let data = await res.data.text();
        data = JSON.parse(data);
        console.log('download single 2: ', data);
        message = data.message || '';
        message && showErrorMessage(message);
      } else if (type === 'stream') {
        const href = window.URL.createObjectURL(res.data);
        const link = document.createElement('a');
        link.download =  file.name; // filename;
        link.href = href;
        link.click();
        window.URL.revokeObjectURL(href);
      } else {
        showErrorMessage('操作失败!');
      }
    })
    .catch((err) => {
      console.error('download error: ', err);
      showErrorMessage('操作失败!');
    });
}

/* 多图下载，服务端返回压缩包文件 */
export function downloadBatch(fileList) {
  axios({
    method: 'post',
    url: config.baseUrl + 'dcwytimgapi/download/batch',
    data: {
      list: fileList,
    },
  })
    .then((res) => {
      console.log('download batch: ', res, Date.now());
      if (res?.data?.data) {
        window.location.href = res.data.data;
      } else {
        showErrorMessage(res.data.message || '操作失败!');
      }
    })
    .catch((err) => {
      console.error('download error: ', err);
      showErrorMessage('操作失败!');
    });
}

// 检测图片url是否合法
export function checkImageUrl(url = '') {
  if (!url || url.startsWith('/')) {
    return false;
  }

  return isValidImgUrl(url);
}

export function getFileInfoByPath(src = '') {
  const list = src.split('/');
  const length = list.length;
  return {
    name: list[length - 1],
  };
}



/**
 * 下载文件函数
 * @param {Object} options - 下载选项
 * @param {string} options.url - 文件URL（可选，与data二选一）
 * @param {Blob|string} options.data - 文件数据（可选，与url二选一）
 * @param {string} options.filename - 下载文件名
 * @param {string} [options.mimeType] - 文件MIME类型（data为字符串时必填）
 * @param {boolean} [options.isBinary] - data是否为二进制数据（默认false）
 * @returns {Promise} - 下载Promise
 */
export const downloadFile = ({
  url,
  filename,
  data,
  mimeType,
  isBinary = false
}) => {
  return new Promise((resolve, reject) => {
    // 验证参数
    if (!filename) {
      reject(new Error('请提供文件名'));
      return;
    }

    if (!url && !data) {
      reject(new Error('请提供文件URL或数据'));
      return;
    }

    // 处理通过URL下载的情况
    if (url) {
      // 对于同源URL或支持CORS的URL，使用fetch处理
      if (url.startsWith(window.location.origin) || url.includes('://')) {
        fetch(url)
          .then(response => {
            if (!response.ok) throw new Error('文件请求失败');
            return response.blob();
          })
          .then(blob => {
            downloadBlob(blob, filename);
            resolve();
          })
          .catch(reject);
      } else {
        // 非标准URL处理（如相对路径）
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.target = '_blank';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        resolve();
      }
      return;
    }

    // 处理通过数据下载的情况
    if (data) {
      let blob;
      if (data instanceof Blob) {
        blob = data;
      } else if (typeof data === 'string') {
        if (!mimeType) {
          reject(new Error('数据为字符串时必须指定MIME类型'));
          return;
        }
        // 根据是否二进制数据处理
        const dataArray = isBinary 
          ? Uint8Array.from(atob(data), c => c.charCodeAt(0))
          : [data];
        
        blob = new Blob(dataArray, { type: mimeType });
      } else {
        reject(new Error('不支持的数据类型'));
        return;
      }

      downloadBlob(blob, filename);
      resolve();
    }
  });
};

/**
 * 通过Blob对象下载文件
 * @param {Blob} blob - Blob对象
 * @param {string} filename - 文件名
 */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.href = url;
  link.download = filename;
  
  // 兼容火狐浏览器
  link.style.display = 'none';
  document.body.appendChild(link);
  
  link.click();
  
  // 清理资源
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
};
